<script lang="ts">
  import CardBody from './CardBody.svelte';
  import CardHeader from './CardHeader.svelte';

  export let subtitle: string;

  export let title: string;

  export let description: string = '';

  export let image: string | undefined = undefined;

  export let imageAlt: string | undefined = undefined;

  export let numberOfInjectedComponents: number;
</script>

<div class="card">
  <CardHeader {subtitle} {title} {description} {numberOfInjectedComponents}>
    <slot name="header" />
  </CardHeader>

  <CardBody {image} {imageAlt} {numberOfInjectedComponents}>
    <slot name="body" />
  </CardBody>
</div>

<style>
  .card {
    background-image: url('$lib/assets/img/launchId/blueprint.jpg');
    border-radius: 20px;
    height: 350px;
    padding: 1rem 1rem;
  }
</style>
